// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonObjects = {
  baseImage: "KVM 系统镜像",
  containerImage: "容器镜像",
  customImage: "自定义镜像",
  applicationImage: "应用镜像",
  dynamipsIosImage: "Dynamips IOS 镜像",
  physicalDevice: "物理设备",
  spec: "规格",
  topologyTemplate: "拓扑模板",
  topologyVersion: "拓扑版本",
  executionSnapshot: "执行快照",
  topologyViewSnapshot: "视图快照",
  containerSpec: "容器规格",
  vmSpec: "虚机规格",
  simulatorModel: "仿真模型",
  loginCredential: "登录凭证",
  accessPort: "访问端口",
  imagePortServiceProtocol: "端口服务协议",
  applicationParameter: "应用参数",
  applicationAction: "应用动作",
  actionInputParameter: "动作输入参数",
  outputItem: "结果输出",
} as const;
